import { motion } from 'framer-motion';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

const ProjectCard = ({ project, index }) => {
  return (
    <motion.div
      whileHover={{ y: -6, boxShadow: '0 10px 0 0 rgba(255,255,255,1)' }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className="relative flex flex-col overflow-hidden rounded-xl border-2 border-white bg-white text-black"
    >
      <span className="absolute left-3 top-3 z-10 flex h-7 w-9 items-center justify-center rounded-md bg-black text-xs font-black text-white">
        {String(index + 1).padStart(2, '0')}
      </span>

      <div
        className="relative flex h-28 items-center justify-center text-4xl"
        style={{ background: `linear-gradient(135deg, ${project.accentColor}33, ${project.accentColor}0D)` }}
      >
        {project.rune}
        {project.live && (
          <span className="absolute right-3 top-3 flex items-center gap-1.5 rounded-full bg-black px-2 py-0.5 text-[10px] font-bold text-white">
            <span className="h-1.5 w-1.5 rounded-full bg-green-400" /> LIVE
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col p-4">
        <div className="mb-1 flex items-start justify-between gap-2">
          <h3 className="line-clamp-2 min-h-[2.5rem] font-black leading-tight">{project.title}</h3>
          <span className="shrink-0 text-xs font-semibold text-black/40">{project.month} {project.year}</span>
        </div>
        <p className="mb-3 line-clamp-2 min-h-[2.6rem] text-sm text-black/60">{project.description}</p>

        <div className="mb-3 flex flex-wrap gap-1.5">
          {project.techStack.map((tech) => (
            <span key={tech} className="rounded-full border border-black/20 px-2 py-0.5 text-xs text-black/60">
              {tech}
            </span>
          ))}
        </div>

        <div className="flex gap-3">
          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-xs font-semibold text-black/70 hover:text-black"
            >
              <FaGithub size={13} /> Code
            </a>
          )}
          {project.live && (
            <a
              href={project.live}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-xs font-semibold text-black/70 hover:text-black"
            >
              <FaExternalLinkAlt size={11} /> Live
            </a>
          )}
          {!project.github && !project.live && (
            <span className="text-xs text-black/30">Private</span>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;
